import React, { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { convertToKebabCase, removeToken } from "../../helpers/helperFunctions";
import { removeAuth } from "../../Store/reducer";
import { AppDispatch, RootState } from "@store/store";
import dashboardIcon from "../../assets/images/dashbaord-icon.png";
import rolesIcon from "../../assets/images/team-roles-icon.png";
import operatorsIcon from "../../assets/images/operators-icon.png";
import customersIcon from "../../assets/images/customers-icon.png";
import doctorsIcon from "../../assets/images/doctors-icon.png";
import categoriesIcon from "../../assets/images/categories-icon.png";
import biomarkersIcon from "../../assets/images/biomarkers-icon.png";
import productsIcon from "../../assets/images/products-icon.png";
import ordersIcon from "../../assets/images/order-icons.png";
import specializaionIcon from "../../assets/images/patient.svg";
import diseasesIcon from "../../assets/images/virus.svg";
import tagImage from "../../assets/images/admin-dashboard/tag-image.png";
import webManage from "../../assets/images/admin-dashboard/web-manage.png";
import analyticsIcon from "../../assets/images/analytisc-icon.png";
import revenueIcon from "../../assets/images/revenue-icon.png";
import discussionsIcon from "../../assets/images/discussions-icon.png";
import withdrawalIcon from "../../assets/images/withdrawal-icon.png";
import supportHubIcon from "src/assets/images/support-hub.png";
import appointmentWhiteIcon from "src/assets/images/appointment-white-icon.png";
import settingIcon from "src/assets/images/settings-icon.png";
import careCredits from "src/assets/images/care-credits-icon.png";
import brandIocn from "src/assets/images/brand-side-icon.png";
import pakacgesIocn from "src/assets/images/pakages-side-icon.png";
import logo from "src/assets/images/shifara-white-logo.png";
import { getIndicators, removeAllIndicators } from "src/Store/redDots";
import { faPowerOff, faSignOut } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const AdminSidebar: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const allowedRoles = userDetails?.userRoleId;
  const isSuperAdmin = userDetails?.isSuperAdmin;
  const { allIndicators } = useSelector((store: RootState) => store?.redDots);
  const hasAccess = (permission: any) => {
    return (
      permission !== "null" &&
      (permission === "read" || permission === "read/write")
    );
  };

  const sideBarItems: {
    title: string;
    child: {
      title: string;
      icons: string;
      url: string;
      count?: any;
      countShown?: boolean;
      permissionKey?: string;
    }[];
  }[] = [
    {
      title: "Dashboard",
      child: [
        { title: "Dashboard", icons: dashboardIcon, url: "/admin" },
        {
          title: "Revenue Management",
          icons: revenueIcon,
          url: "/revenue-management",
        },
        { title: "Analytics", icons: analyticsIcon, url: "/analytics" },
      ],
    },
    {
      title: "Administration",
      child: [
        {
          title: "Roles",
          icons: rolesIcon,
          url: "/admin/roles",
          permissionKey: "rolesOperatorManagement",
        },
        {
          title: "Operators",
          icons: operatorsIcon,
          url: "/admin/operators",
          permissionKey: "rolesOperatorManagement",
        },
        // { title: "Website Manage", icons: settingIcon, url: "/admin/pharmacy/website-manage" },
        {
          title: "Manage Home Page",
          icons: webManage,
          url: "/admin/manage-home-page",
          permissionKey: "platformManagement",
        },
        {
          title: "Tags",
          icons: tagImage,
          url: "/admin/tags",
          permissionKey: "platformManagement",
        },
        {
          title: "Specializations",
          icons: specializaionIcon,
          url: "/admin/specialization",
          permissionKey: "platformManagement",
        },
        {
          title: "Diseases",
          icons: diseasesIcon,
          url: "/admin/disease",
          permissionKey: "platformManagement",
        },
        // { title: "Appointment", icons: appointmentWhiteIcon, url: "/all-appointments", count: allIndicators?.adminOnlineAppointment || allIndicators?.adminPhysicalAppointment > 0 ? allIndicators?.adminPhysicalAppointment + allIndicators?.adminOnlineAppointment : 0, permissionKey: "userAppointmentManagement" },
        // { title: "Withdrawal", icons: withdrawalIcon, url: "/withdrawal-requests", count: allIndicators?.adminPendingWithdraw > 0 ? allIndicators?.adminPendingWithdraw : 0, permissionKey: "userAppointmentManagement" },
        {
          title: "Support Hub",
          icons: supportHubIcon,
          url: "/admin/supporthub",
          count:
            allIndicators?.adminSupportHub > 0
              ? allIndicators?.adminSupportHub
              : 0,
          permissionKey: "platformManagement",
        },
        // {
        //   title: "Care Credits",
        //   icons: careCredits,
        //   url: "/admin/care-credits",
        //   permissionKey: "platformManagement",
        // },
        {
          title: "Commission settings",
          icons: settingIcon,
          url: "/platform-settings",
          permissionKey: "platformManagement",
        },
      ],
    },
    {
      title: "User Management",
      child: [
        {
          title: "Overview",
          icons: dashboardIcon,
          url: "/admin/user/overview",
        },
        {
          title: "Doctors",
          icons: doctorsIcon,
          url: "/doctors",
          count:
            allIndicators?.doctor_verfication ||
            allIndicators?.doctor_indicators ||
            allIndicators?.diagnosticOrderDoctor > 0
              ? allIndicators?.diagnosticOrderDoctor +
                allIndicators?.doctor_indicators +
                allIndicators?.doctor_verfication
              : 0,
          countShown: false,
          permissionKey: "userManagement",
        },
        {
          title: "Customers",
          icons: customersIcon,
          url: "/customers",
          count:
            allIndicators?.customers_verfication ||
            allIndicators?.customers_indicators ||
            allIndicators?.diagnosticOrderCustomer > 0
              ? allIndicators?.diagnosticOrderCustomer +
                allIndicators?.customers_indicators +
                allIndicators?.customers_verfication
              : 0,
          permissionKey: "userManagement",
        },
        {
          title: "Appointment",
          icons: appointmentWhiteIcon,
          url: "/all-appointments",
          count:
            allIndicators?.adminOnlineAppointment ||
            allIndicators?.adminPhysicalAppointment > 0
              ? allIndicators?.adminPhysicalAppointment +
                allIndicators?.adminOnlineAppointment
              : 0,
          permissionKey: "userAppointmentManagement",
        },
        {
          title: "Withdrawal",
          icons: withdrawalIcon,
          url: "/withdrawal-requests",
          count:
            allIndicators?.adminPendingWithdraw > 0
              ? allIndicators?.adminPendingWithdraw
              : 0,
          permissionKey: "userAppointmentManagement",
        },
        // { title: "Doctors", icons: doctorsIcon, url: "/doctors", count: allIndicators?.doctor_indicators || false },
        // { title: "Customers", icons: customersIcon, url: "/customers", count: allIndicators?.customers_indicators || false },
      ],
    },
    // {
    //   title: "Customers Management", child: [
    //     { title: "Customers", icons: customersIcon, url: "/customers", count: allIndicators?.customers_indicators || false, },
    //   ]
    // },
    {
      title: "Diagnostics",
      child: [
        {
          title: "Overview",
          icons: dashboardIcon,
          url: "/admin/diagnostics/overview",
        }, // UI-change icon
        {
          title: "Biomarkers",
          icons: biomarkersIcon,
          url: "/admin/diagnostics/biomarkers",
          permissionKey: "diagnosticTest",
        },
        {
          title: "Test Categories",
          icons: categoriesIcon,
          url: "/admin/diagnostics/categories",
          permissionKey: "diagnosticTest",
        },
        {
          title: "Test Products",
          icons: productsIcon,
          url: "/admin/diagnostics/products",
          permissionKey: "diagnosticTest",
        },
        {
          title: "Test Orders",
          icons: ordersIcon,
          url: "/all-orders",
          count:
            allIndicators?.diagnosticOrder > 0
              ? allIndicators?.diagnosticOrder
              : 0,
          permissionKey: "diagnosticOrder",
        },
        {
          title: "Packages",
          icons: pakacgesIocn,
          url: "/admin/packages",
          permissionKey: "diagnosticTest",
        },
      ],
    },
    {
      title: "Pharmacy",
      child: [
        {
          title: "Overview",
          icons: dashboardIcon,
          url: "/admin/pharmacy/overview",
        },
        {
          title: "Brands",
          icons: brandIocn,
          url: "/admin/pharmacy/brands",
          permissionKey: "pharmaInventory",
        },
        {
          title: "Pharma Categories",
          icons: categoriesIcon,
          url: "/admin/pharmacy/main-categories",
          permissionKey: "pharmaInventory",
        },
        {
          title: "Pharma Inventory",
          icons: productsIcon,
          url: "/admin/pharmacy/pharma-inventory",
          permissionKey: "pharmaInventory",
        },
        {
          title: "Prescriptions",
          icons: productsIcon,
          url: "/admin/pharmacy/prescriptions",
          permissionKey: "pharmaInventory",
          count:
            (allIndicators?.customers_prescribe_unvalid || 0) +
            (allIndicators?.customers_prescribe_valid || 0),
        },
        {
          title: "Pharma Orders",
          icons: ordersIcon,
          url: "/admin/pharmacy/all-orders",
          count:
            allIndicators?.pharmacyOrder > 0 ? allIndicators?.pharmacyOrder : 0,
          permissionKey: "pharmaOrder",
        },
        // { title: "Pharmacy Management", icons: settingIcon, url: "/admin/pharmacy/website-manage", permissionKey: "pharmaInventory" },
      ],
    },
    {
      title: "Homecare",
      child: [
        {
          title: "Overview",
          icons: dashboardIcon,
          url: "/admin/homecare-overview",
        },
        {
          title: "Homecare Categories",
          icons: categoriesIcon,
          url: "/admin/homecare-categories",
          permissionKey: "homeServiceManagement",
        },
        {
          title: "Homecare Services",
          icons: productsIcon,
          url: "/admin/homecare-services",
          permissionKey: "homeServiceManagement",
        },
        {
          title: "Homecare Appointment",
          icons: appointmentWhiteIcon,
          url: "/admin/homecare-appointments",
          count:
            allIndicators?.homeCareOrder > 0 ? allIndicators?.homeCareOrder : 0,
          permissionKey: "homeServiceAppointment",
        },
      ],
    },
    {
      title: "Discussion",
      child: [
        {
          title: "Discussions",
          icons: discussionsIcon,
          url: "/discussions-list",
          count:
            allIndicators?.adminPendingDiscussion > 0
              ? allIndicators?.adminPendingDiscussion
              : 0,
          permissionKey: "platformManagement",
        },
      ],
    },
  ];

  const handleLogOut = () => {
    removeToken();
    dispatch(removeAuth());
    dispatch(removeAllIndicators());
    navigate("/admin/login");
  };
  useEffect(() => {
    dispatch(getIndicators("/operators/admin-indicators"));
  }, [location?.pathname]);

  const convertToID = (str: string) => {
    if (!str) return "tab";
    return str.replace(/ /g, "-").toLowerCase();
  };

  return (
    <div className="sidebar flex flex-col  fixed top-0">
      <Link to="/admin" className="sidebarlogo-parent-logo">
        <img src={logo} alt="" />
      </Link>
      <div className="flex-1 overflow-y-auto scrollbar-yellow">
        <div className="sidebar-navigation-parent">
          {sideBarItems.map((item, index) => {
            const visibleChildren = item.child.filter(
              (v: any) =>
                isSuperAdmin || hasAccess(allowedRoles?.[v.permissionKey])
            );

            if (visibleChildren.length === 0) return null;
            return (
              <div key={index}>
                <div className="bg-white bg-opacity-30 ps-6 py-1">
                  <span className="text-white font-Poppins-Medium font-size-13px">
                    {item?.title || ""}
                  </span>
                </div>
                <ul>
                  {/* {item.child.map((v, i) => ( */}
                  {item.child
                    .filter(
                      (v: any) =>
                        isSuperAdmin ||
                        hasAccess(allowedRoles?.[v.permissionKey])
                    )
                    .map((v, i) => (
                      <li
                        key={i}
                        id={convertToID(v?.title)}
                        className={`sidebar-navigation ${
                          location.pathname === v.url ||
                          location.pathname === `${v.url}/`
                            ? "active"
                            : ""
                        }`}
                      >
                        <Link
                          to={v?.url || "/"}
                          id={`${convertToKebabCase(
                            item?.title || ""
                          )}-${convertToKebabCase(v?.title || "")}`}
                          className={`sidebar-navigation-vendor flex items-center text-white`}
                        >
                          <img
                            className="sidebar-icon"
                            src={v?.icons}
                            alt={v?.title || ""}
                          />
                          <span className="capitalize font-Poppins-Regular font-size-15px sidebar-nav-text">
                            {v?.title || ""}
                          </span>
                          {v?.count ? (
                            v?.countShown ? (
                              <div className="red-dot-show">
                                <p className="font-Poppins-SemiBold text-white font-size-11px">
                                  {v.count}
                                </p>
                              </div>
                            ) : (
                              <div className="red-dot-show-only-dot"></div>
                            )
                          ) : null}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
      <div className="w-full flex justify-center h-fit py-3 border-t mt-6 border-[#34644a]">
        <div className="logut-btn">
          <button
            onClick={handleLogOut}
            id="logout-btn"
            className="text-white p-3 px-9 rounded-full capitalize font-Poppins-Medium font-size-18px"
          >
            <FontAwesomeIcon icon={faPowerOff} /> Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;
